/* eslint-disable react/display-name */
import { memo } from 'react';

import { useParams } from 'react-router-dom';

import ReportVersion from '../Form';
const CreateReportVersionStatement = memo(() => {
  const { reportId } = useParams<any>();
  return (
    <div>
      <ReportVersion defaultValue={{ reportId }} />
    </div>
  );
});

export default CreateReportVersionStatement;
